<template>

  <t-page>
    
    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle" :to="currentPage.name + '-form-new'"
                  primary/>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form" />
      </template>


      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="fields"
               primary-key-column="typeEnterpriseNumber" link-primary-column="name"/>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'TypeEnterprise',
  data() {
    return {
      enableGeneralFields: false,
      fields: [
        {key: "name", label: "Tipo de Empreendimento"},
        {key: "note", label: "Obs."},
        {key: "status", label: "Status"},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'place-setting'}},
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>

